import React, { useState, useEffect } from 'react';
import './about.scss';
import Header from '../components/headerBar';
import Footer from '../components/footer';
import COMPANY_INTRO_IMG from '../assets/about/conpany_intro.png';
import LENET_IMG from '../assets/about/lenet.png';
import SLOGAN_IMG from '../assets/about/slogan.png';
import { useHistory, useLocation, useParams } from 'react-router-dom';

const map = Object.freeze({
  a: {
    en: `Shandong Fantai Fine Chemical Biotechnology Co., Ltd. is located in Weifang, the world's kite capital, the transportation hub of Shandong Province, with superior geographical location and convenient transportation`,
    'zh-cn': '山东钒泰精化生物科技有限公司位于山东省交通枢纽世界风筝之都潍坊，地理位置优越、交通便利',
  },
  b: {
    en:
      'The team has had many years of custom synthesis cooperation with domestic and foreign drug research and development related companies and units, with the purpose of building the company into a fine chemical enterprise engaged in the research and development, production and sales of fine chemicals, pharmaceutical intermediates and raw materials. The company is now striving to build a one-stop procurement platform from basic reagents to high-end chemicals to realize a green chemical platform. Based on the concept of mutual benefit and win-win cooperation, we are willing to sincerely cooperate with new and old customers to create brilliance and jointly promote the development of the industry. Contribute to our living environment.',
    'zh-cn':
      '钒泰团队有多年与国内外药物研发相关企业及单位定制合成的合作，目的是将公司建设成一家从事精细化学品、医药中间体和原料的研发、生产和销售的精细化工企业。公司现着力打造从基础试剂到高端化学品的一站式采购平台，实现绿色化工平台。本着互惠互利、合作共赢的理念，愿与新老客户精诚合作、共创辉煌，共同促进行业的发展。为我们的生存环境贡献一份力量。',
  },
});

const About = () => {
  const [la, setLa] = useState<'en' | 'zh-cn'>('zh-cn');
  const location = useLocation();

  const { lang } = useParams();
  useEffect(() => {
    setLa(lang || 'en');
  }, [location.pathname]);

  return (
    <div className='about'>
      <Header />
      <div className='about-content'>
        <div className='company-introduction'>
          <div className='introduction-content'>
            <div className='content-left'>
              <div className='content-title-content'>
                <div className='content-title'>企业介绍</div>
                <div className='content-sub-title'>Corporate introduction</div>
              </div>
              <div className={`content ${lang}`}>
                <p>{map.a[la]}</p>
                <p>{map.b[la]}</p>
              </div>
            </div>
            <div className='content-right'>
              <img src={COMPANY_INTRO_IMG} alt='' />
            </div>
          </div>
        </div>
        <div className='company-flag'></div>
      </div>

      <div className='company-flag-content'>
        <img src={SLOGAN_IMG} alt='' className='slogan' />
        <img src={LENET_IMG} alt='' className='tenet' />
        {/* <div className='corporate'>
          <div className='corporate-left'>
            <img src='' alt='' />
          </div>
          <div className='corporate-right'>
            <div className='title-content'>
              <div className='title'>企业宗旨</div>
              <div className='sub-title'>Corporate tenet</div>
            </div>
            <div className='slogan'>
              <p className='content'>德品立人，诚信立企，</p>
              <p className='content'>质量立市，服务立业。</p>
            </div>
          </div>
        </div>
        <div className='corporate'>
          <div className='corporate-left'>
            <img src='' alt='' />
          </div>
          <div className='corporate-right'>
            <div className='title-content'>
              <div className='title'>企业标语</div>
              <div className='sub-title'>Corporate slogan</div>
            </div>
            <div className='slogan'>
              <p className='content'>质量取胜，信誉取胜，</p>
              <p className='content'>绿色化工。</p>
            </div>
          </div>
        </div> */}
      </div>
      <Footer />
    </div>
  );
};

export default About;
